import React, { useState } from 'react';
import logo_nophoto from '../assets/nophoto.png';
import '../styles/Reserve.css';
import { isDemoKey } from "../services/kdoServices";

function Reserve({p_object,p_key,p_isProprio,p_withButton = true, p_onReserved, p_btnLabel = "Réserver", p_btnClassName = "kdo-res-btn"}) {

    const [isformReserve, setisformReserve] = useState(false)
    const [emailValue, setEmailValue] = useState('')
    const [nomValue, setNomValue] = useState('')
    const [isDataRegistering, setIsDataRegistering] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)
    const [isError, setError] = useState(false)
    const [tmpKey] = useState(() => Date.now());

    function handleInputMail(e) {
		setEmailValue(e.target.value)
	}
    function handleInputNom(e) {
		setNomValue(e.target.value)
	}

    async function requestReservation()
    {
        if(isValidEmail(emailValue))
        {
            if(isDemoKey(p_key))
            {
                alert("Mode démonstration, la reservation n'est faite que dans cette session de démo, elle disparaitra si vous rechargez de la page.")
                const reservationId = -1;
                p_object.reservationid = reservationId
                if (typeof p_onReserved === "function") {
                    p_onReserved(reservationId);
                }
                setIsCompleted(true);
            }
            else
            {
                registerReservation(nomValue,emailValue,p_object.id)
            }
        }
        else
        {
            alert("Attention, ceci n'est pas une adresse valide 😥")
        }
    }

    async function registerReservation(p_nom, p_email,p_idObject) {

        console.log("registerReservation debut");
        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: p_email,
                name : p_nom,
                idObject : p_idObject
            }),
        };

        try {
            let v_responseJson = {};
                console.log("tmpKey " + tmpKey);
                setIsDataRegistering(true)
                const response = await fetch("https://app.listaki.fr/api/WS/reservation.php?key="+tmpKey, requestOptions)
                if (response.ok) {
                    v_responseJson = await response.json();
                    console.log("Reponse api debut");
                    console.log(v_responseJson)
                    console.log("Reponse api fin");
                    if(v_responseJson["success"]) {
                        const reservationId = v_responseJson["reservationId"];
                        p_object.reservationid = reservationId;
                        if (typeof p_onReserved === "function") {
                            p_onReserved(reservationId);
                        }
                    }
                    else alert(v_responseJson["error"])
                    setIsCompleted(true);
                } else {
                    console.log("Erreur lors de l'appel à l'API");
                    v_responseJson = await response.json();
                    if(v_responseJson["error"]) alert(v_responseJson["error"])
                    setError(true);
                }
        } catch (err) {
            console.log(err)
        } finally {
            setIsDataRegistering(false)
        }
    };

    function isValidEmail(p_email) {
        console.log(p_email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(p_email);
    }

    const rawTitle = p_object.title || p_object.objectname || '';
    const v_title = rawTitle.length > 50 ? rawTitle.substring(0, 50) + "..." : rawTitle;
    const v_link = p_object.affiliateLink
        || (p_object.tinyCode ? 'https://fliz.ly/' + p_object.tinyCode + '_w' : null)
        || p_object.url
        || p_object.urllink;
    const v_isReserved = p_object.reservationid != null;

    return !v_isReserved & isformReserve ? (
        <div className="ui-overlay" onClick={() => setisformReserve(false)}>
            <div className="ui-modal" onClick={e => e.stopPropagation()}>
                <h2>Réserver ce cadeau</h2>

                {/* Mini aperçu produit */}
                <div className="kdo-res-product-mini">
                    <img
                        className="kdo-res-product-thumb"
                        src={p_object.imagelink || logo_nophoto}
                        alt={v_title}
                        onError={e => { e.target.src = logo_nophoto; }}
                    />
                    <div style={{flex:1, minWidth:0}}>
                        <div className="kdo-res-product-name">{v_title}</div>
                        {p_object.price > 0 && (
                            <div className="kdo-res-product-price">{p_object.price} €</div>
                        )}
                    </div>
                </div>

                {/* Champ nom */}
                <div className="kdo-res-field">
                    <label className="kdo-res-label">
                        Votre nom <span style={{fontWeight:400, color:'var(--color-muted)', fontSize:'12px'}}>(optionnel)</span>
                    </label>
                    <input
                        className="kdo-res-input"
                        placeholder="Sophie, Papa, La team du boulot…"
                        onChange={handleInputNom}
                        value={nomValue}
                    />
                </div>

                {/* Champ email */}
                <div className="kdo-res-field">
                    <label className="kdo-res-label">
                        Votre e-mail
                        <span className="kdo-res-required-badge">requis</span>
                    </label>
                    <input
                        className="kdo-res-input"
                        type="email"
                        placeholder="votre@email.fr"
                        onChange={handleInputMail}
                        value={emailValue}
                    />
                    <p className="kdo-res-hint">Pour recevoir une confirmation. Seul le propriétaire de la liste peut le consulter.</p>
                </div>

                {/* Banner anonymat */}
                <div className="kdo-res-anon-banner">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" aria-hidden="true" style={{flexShrink:0}}>
                        <path d="M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0m0 1V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4M6 13v1a6 6 0 0 0 12 0v-3"/>
                    </svg>
                    <p className="kdo-res-anon-text"><strong>Votre nom reste discret</strong> — Les autres utilisateurs ne voient pas qui a réservé. Seul le propriétaire de la liste peut le consulter, s'il le souhaite.</p>
                </div>

                {/* Rappel : la réservation n'achète rien */}
                <div className="kdo-res-buy-banner" role="note">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" aria-hidden="true" style={{flexShrink:0}}>
                        <circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>
                    </svg>
                    <p className="kdo-res-buy-text"><strong>Pensez à commander l'article</strong> — Réserver sur Listaki ne fait pas l'achat : commandez-le directement sur le site du marchand ou en magasin. La réservation indique simplement aux autres utilisateurs que quelqu'un va l'acheter.</p>
                </div>

                <button
                    className="kdo-res-cta"
                    onClick={() => {
                        if (window.umami) window.umami.track('reserve-object');
                        requestReservation();
                    }}
                    disabled={isDataRegistering || !emailValue}
                >
                    {isDataRegistering ? "Réservation en cours…" : "Confirmer ma réservation"}
                </button>
            </div>
        </div>
    ) : v_isReserved & isformReserve ? (
        <div className="ui-overlay" onClick={() => setisformReserve(false)}>
            <div className="ui-modal" onClick={e => e.stopPropagation()}>
                <div style={{textAlign:'center', padding:'8px 0 16px'}}>
                    <div style={{width:48, height:48, borderRadius:'50%', background:'#DCFCE7', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px'}}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2.5" aria-hidden="true">
                            <path d="M20 6L9 17l-5-5"/>
                        </svg>
                    </div>
                    <h2 style={{margin:'0 0 6px'}}>Réservation confirmée !</h2>
                    <p style={{color:'var(--color-muted)', fontSize:'14px', margin:'0 0 16px'}}>
                        Merci ! Un e-mail de confirmation vous a été envoyé.
                    </p>
                    <p style={{color:'#854D0E', background:'#FEF9C3', borderRadius:'12px', fontSize:'13px', lineHeight:1.4, padding:'10px 14px', margin:'0 0 16px', textAlign:'left'}}>
                        <strong>N'oubliez pas de commander l'article</strong> sur le site du marchand ou en magasin : la réservation prévient seulement les autres utilisateurs que quelqu'un va l'acheter.
                    </p>
                    {v_link && (
                        <a
                            href={v_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{display:'inline-block', background:'var(--color-tint)', color:'var(--color-primary-hover)', borderRadius:'12px', padding:'10px 20px', fontWeight:700, fontSize:'14px', textDecoration:'none'}}
                        >
                            Voir le produit →
                        </a>
                    )}
                </div>
            </div>
        </div>
    ) : v_isReserved ?
    (
        <div className='kdo-reserved-ribbon' aria-label='Objet réservé'>
            Réservé
        </div>
    ) : (
        !p_isProprio && p_withButton ? (
            <button className={p_btnClassName} onClick={() => setisformReserve(true)}>{p_btnLabel}</button>
        ) : null
    )

};

export default Reserve;
